import { SOURCE_SYSTEMS, normalizeSourceSystem } from '@process-advisor/process-miner/sources/capabilities';

export const SHARED_METRICS_PROFILE = Object.freeze({
  sourceSystem: SOURCE_SYSTEMS.GENERIC,
  dashboardTabs: ['metrics', 'segments', 'variants', 'transitions'],
  metricFamilies: ['volume', 'leadTime', 'variants', 'transitions', 'rework', 'flow'],
});

export const JIRA_METRICS_PROFILE = Object.freeze({
  ...SHARED_METRICS_PROFILE,
  sourceSystem: SOURCE_SYSTEMS.JIRA,
  platformMetricFamilies: ['jiraWorkflow', 'issueType', 'project', 'automation'],
});

export const SERVICE_NOW_METRICS_PROFILE = Object.freeze({
  ...SHARED_METRICS_PROFILE,
  sourceSystem: SOURCE_SYSTEMS.SERVICENOW,
  dashboardTabs: ['metrics', 'slaMetrics', 'segments', 'variants', 'transitions'],
  platformMetricFamilies: [
    'assignmentGroupRouting',
    'assigneeOwnership',
    'approvalDwell',
    'changePhase',
    'classificationChurn',
    'serviceContext',
    'slaAdjacent',
    'slaMetrics',
  ],
});

export function getMetricsProfileForSource(sourceSystem) {
  switch (normalizeSourceSystem(sourceSystem)) {
    case SOURCE_SYSTEMS.SERVICENOW:
      return SERVICE_NOW_METRICS_PROFILE;
    case SOURCE_SYSTEMS.JIRA:
      return JIRA_METRICS_PROFILE;
    default:
      return SHARED_METRICS_PROFILE;
  }
}
